import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import RecipientSelectionImage from "images/recipient-selection-image.svg";
import SenderSelectionImage from "images/sender-selection-image.svg";
import { Link, useNavigate } from "react-router-dom";
import * as CSC from "SC";
import { SignUpLayout } from "./SignUpLayout";
import { DevIndicator } from "./DevIndicator";

const Item = ({
  image,
  title,
  text,
  link,
  linkLabel,
  externalLink = "https://referral-stream.webflow.io",
}) => (
  <div className="flex flex-col justify-stretch items-start p-4 divide-y sm:w-1/2">
    <div className="text-xl flex flex-row sm:flex-col items-center sm:items-start gap-2 mt-1 mb-3">
      <img src={image} alt={title} />
      <div className="font-semibold">{title}</div>
    </div>
    <div>
      <div className="pt-2 pb-2">{text}</div>
      <Link to={externalLink}>What is a {title}?</Link>
      <div className="pt-4 pb-2 w-full">
        <Link to={link}>
          <CSC.BlueButton variant="contained" sx={{ width: "100%" }}>
            {linkLabel}
          </CSC.BlueButton>
        </Link>
      </div>
    </div>
  </div>
);

export const SignUpVariants = () => {
  const navigate = useNavigate();

  return (
    <SignUpLayout>
      <DevIndicator />
      <div className="bg-white p-4 sm:p-8 rounded-2xl flex flex-col justify-center items-start sm:gap-2 max-w-2xl relative">
        <IconButton
          sx={{ position: "absolute", right: 4, top: 4 }}
          size="small"
          onClick={() => navigate("/")}
        >
          <CloseIcon />
        </IconButton>
        <div className="text-xl sm:text-2xl font-bold mr-4">
          Register an Account That’s Right for You!
        </div>
        <div>
          Please select the role that best fits your needs and let's get
          started!
        </div>
        <div className="mt-4 flex flex-col sm:flex-row rounded-xl border border-solid border-gray-300 divide-x divide-y sm:divide-y-0">
          <Item
            image={RecipientSelectionImage}
            title="Recipient"
            text="Recipients can easily receive referrals from their providers."
            link="/sign_up/recipient"
            linkLabel="Sign Up"
            externalLink="https://referral-stream.webflow.io/"
          />
          <Item
            image={SenderSelectionImage}
            title="Sender"
            text="Senders have a quick and easy way to refer patients."
            link="/sign_up/sender"
            linkLabel="Sign Up"
            externalLink="https://referral-stream.webflow.io/"
          />
        </div>
      </div>
    </SignUpLayout>
  );
};
